import React, { useState } from 'react';

const Portfolio = () => {
  const [activeFilter, setActiveFilter] = useState('all');

  const filters = [
    { id: 'all', label: 'All work' },
    { id: 'web', label: 'Web' },
    { id: 'mobile', label: 'Mobile' },
    { id: 'edtech', label: 'EdTech' }
  ];

  const portfolioItems = [
    {
      id: 1,
      category: 'web edtech',
      title: 'Kidsphere',
      description: 'Flagship EdTech product—gamified life-skills learning with analytics and secure parent controls, built for scale.',
      image: '/kidsphere logo/logo.png',
      link: 'https://kidsphere.in',
      tech: ['React', 'Node.js', 'MongoDB', 'AI/ML'],
      isLogo: true
    },
    {
      id: 2,
      category: 'web',
      title: 'E-Commerce Platform',
      description: 'High-traffic commerce stack with hardened checkout flows, observability, and payment integrations built for reliability.',
      image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&h=600&fit=crop',
      link: '#',
      tech: ['Next.js', 'Stripe', 'PostgreSQL']
    },
    {
      id: 3,
      category: 'mobile',
      title: 'Fitness Tracker',
      description: 'Consumer mobile experience with real-time telemetry, personalization, and backend APIs engineered for uptime.',
      image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&h=600&fit=crop',
      link: '#',
      tech: ['React Native', 'Firebase']
    },
    {
      id: 4,
      category: 'web cloud',
      title: 'Cloud Infrastructure',
      description: 'Internal cloud control plane—GitOps-style delivery, monitoring, and cost visibility for platform teams.',
      image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&h=600&fit=crop',
      link: '#',
      tech: ['AWS', 'Docker', 'Kubernetes']
    },
    {
      id: 5,
      category: 'web',
      title: 'Healthcare Portal',
      description: 'Regulatory-aware web portal—secure records workflows, role-based access, and telehealth-ready integrations.',
      image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=800&h=600&fit=crop',
      link: '#',
      tech: ['Vue.js', 'Python', 'MySQL']
    },
    {
      id: 6,
      category: 'mobile edtech',
      title: 'Learning Platform',
      description: 'Mobile learning with adaptive paths, offline-friendly patterns, and engagement analytics for educators.',
      image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&h=600&fit=crop',
      link: '#',
      tech: ['Flutter', 'Firebase', 'AI/ML']
    }
  ];

  const filteredItems = activeFilter === 'all' 
    ? portfolioItems 
    : portfolioItems.filter(item => item.category.includes(activeFilter));

  return (
    <section id="portfolio" className="portfolio">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">Our work</span>
          <h2 className="section-title">Featured delivery</h2>
          <p className="section-description">
            Product builds, cloud-backed platforms, and secure user experiences—examples of how we ship when strategy has to survive real traffic and real incidents.
          </p>
        </div>

        <div className="portfolio-filters">
          {filters.map(filter => (
            <button
              key={filter.id}
              className={`filter-btn ${activeFilter === filter.id ? 'active' : ''}`}
              onClick={() => setActiveFilter(filter.id)}
            >
              {filter.label}
            </button>
          ))}
        </div>

        <div className="portfolio-grid">
          {filteredItems.map((item) => (
            <div key={item.id} className="portfolio-card">
              <div className="portfolio-image-wrapper">
                {item.isLogo ? (
                  <div className="portfolio-logo-container">
                    <img src={item.image} alt={item.title} className="portfolio-logo" />
                  </div>
                ) : (
                  <img 
                    src={item.image} 
                    alt={item.title} 
                    className="portfolio-image"
                    onError={(e) => {
                      e.target.src = 'https://images.unsplash.com/photo-1557682250-33bd709cbe85?w=800&h=600&fit=crop';
                    }}
                    loading="lazy"
                  />
                )}
                <div className="portfolio-overlay">
                  <a 
                    href={item.link} 
                    target={item.link !== '#' ? "_blank" : undefined}
                    rel={item.link !== '#' ? "noopener noreferrer" : undefined}
                    className="portfolio-link"
                    onClick={(e) => {
                      if (item.link === '#') {
                        e.preventDefault();
                      }
                    }}
                  >
                    View Project
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </a>
                </div>
              </div>
              <div className="portfolio-content">
                <div className="portfolio-categories">
                  {item.category.split(' ').map((cat, idx) => (
                    <span key={idx} className="category-tag">{cat}</span>
                  ))}
                </div>
                <h3 className="portfolio-title">{item.title}</h3>
                <p className="portfolio-description">{item.description}</p>
                <div className="portfolio-tech">
                  {item.tech.map((tech, idx) => (
                    <span key={idx} className="tech-tag">{tech}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
